<template>
	<div>
		<div class="modal-header">
			<h5 class="modal-title">Log Approval</h5>
			<a class="text-dark btn-close pt-1" aria-hidden="true" href="#" @click.prevent="distrupNav">
				<span aria-hidden="true"><b>&times;</b></span>
			</a>
		</div>
		<div class="modal-body mt-3">
			<div class="nav-wrapper">
				<ul class="nav nav-pills nav-fill mb-3" role="tablist">
					<li class="nav-item">
						<a class="nav-link" :class="{ active: activeTab === 'approvalTracking' }" role="tab" style="cursor: pointer;" @click="activeTab = 'approvalTracking'">Approval Tracking</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" :class="{ active: activeTab === 'nextApproval' }" role="tab" style="cursor: pointer;" @click="activeTab = 'nextApproval'">Next Approval</a>
					</li>
				</ul>
				<div class="tab-content">
					<div v-if="!modalTrackingOrderHostory.onLoadLogTrack" id="approvalTracking" class="tab-pane fade" :class="{ 'show active': activeTab === 'approvalTracking' }" role="tabpanel">
						<div v-if="modalTrackingOrderHostory.data.logTracking && modalTrackingOrderHostory.data.logTracking.length != 0" class="px-3 pb-3 pt-0">
							<div class="px-2 py-4">
								<h6 class="mb-0">Log Tracking</h6>
							</div>
							<div class="timeline timeline-one-side" data-timeline-axis-style="dashed">
								<timeline-item v-for="logAppr in modalTrackingOrderHostory.data.logTracking" :key="logAppr.id"
									:icon="getResultIcon(logAppr.result)"
									:tooltip="getResultIcon(logAppr.result).tooltip"
									:title="logAppr.executedByName"
									:subtitle="logAppr.executedByDepartment"
									:role="logAppr.executedByRole"
									:date-time="logAppr.created_at"
									:description="logAppr.note"
									:badges="[logAppr.message]"
								/>
							</div>
						</div>
						<div v-else class="text-center align-middle mt-9">
							<span>No Data</span>
						</div>
					</div>
					<div v-else id="approvalTracking" class="tab-pane fade" :class="{ 'show active': activeTab === 'approvalTracking' }" role="tabpanel">
						<SkeletonLoading
							class="px-4 pt-5"
							:shapes="[
								{ type: 'line', width: '100%', height: '20px' },
								{ type: 'line', width: '80%', height: '20px' },
								{ type: 'line', width: '60%', height: '20px' }
							]"
						/>
					</div>
					<div v-if="!modalTrackingOrderHostory.onLoadnextApprv" id="nextApproval" class="tab-pane fade" :class="{ 'show active': activeTab === 'nextApproval' }" role="tabpanel">
						<table class="table">
							<thead class="table-primary text-center">
								<tr class="align-middle">
									<th class="text-uppercase text-start text-dark text-xxs font-weight-bolder h-100 w-30">
											Name
									</th>
									<th class="text-uppercase text-start text-dark text-xxs font-weight-bolder h-100 w-30">
											Role
									</th>
									<th class="text-uppercase text-start text-dark text-xxs font-weight-bolder h-100 w-40">
											Department
									</th>
								</tr>
							</thead>
							<tbody v-if="modalTrackingOrderHostory.data.nextApprv.length">
								<tr v-for="(user, idx) in modalTrackingOrderHostory.data.nextApprv" :key="idx" class="align-middle">
									<td class="text-sm py-3 px-4">
										<div>{{ user.name }}</div>
									</td>
									<td class="text-sm py-3 px-4 value-table-wrapped" style="min-width: 8cm;">
										<div>{{ user.role }}</div>
									</td>
									<td class="text-sm py-3 px-4 value-table-wrapped" style="min-width: 5cm;">
										<div>{{ user.department }}</div>
									</td>
								</tr>
							</tbody>
							<tbody v-else style="height: 300px;">
								<tr><td class="text-center align-middle" colspan="3">No Data</td></tr>
							</tbody>
						</table>
					</div>
					<div v-else id="nextApproval" class="tab-pane fade" :class="{ 'show active': activeTab === 'nextApproval' }" role="tabpanel">
						<SkeletonLoading
							class="px-4 pt-5"
							:shapes="[
								{ type: 'line', width: '100%', height: '20px' },
								{ type: 'line', width: '80%', height: '20px' },
								{ type: 'line', width: '60%', height: '20px' }
							]"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import TimelineItem from "@/components/TimelineItem.vue";
import SkeletonLoading from "@/components/SkeletonLoading.vue";
import transactionLogService from '@/services/report/appAuditing/transactionLogService';
import api from '@/helpers/api';

var moment = require('moment');

export default {
	components: {
    TimelineItem,
		SkeletonLoading
	},
	emits: ['close'],
	data() {
		return  {
			activeTab: 'approvalTracking',
			modalTrackingOrderHostory: {
        data: {
          logTracking: [],
          nextApprv: []
        },
        onLoadLogTrack: false,
        onLoadnextApprv: false
      },
		}
	},
	methods: {
		getTracking({ type, code, key, result } = {}) {
			// Reset ke tab pertama tiap kali dibuka
			this.activeTab = 'approvalTracking'
			// Muat log tracking & next approval secara paralel (independen)
			this.getLogTracking({ type, code, key, result })
			this.getNextApproval({ key })
		},
		async getLogTracking({ type, code, key, result } = {}) {
      this.modalTrackingOrderHostory.onLoadLogTrack = true
      try {
        // Bangun payload hanya dari parameter yang terisi (semua optional)
        const payload = {}
        if (type) payload.type = Array.isArray(type) ? type : [type]
        if (code) payload.code = code
        if (key) payload.key = key
        if (result) payload.result = result

        const responseTransLog = await api(this, transactionLogService.tracking(payload, { sort_by: 'id', tracking: true }), false)

        const logs = (responseTransLog.data || []).map(item => {
          // executed_by berupa JSON string → parse sekali untuk nama & departemen
          const executor = this.parseExecutedBy(item.executed_by)
          return {
            ...item,
            note: item.note === "\"\"" ? '' : item.note,
            executedByName: executor.name,
            executedByDepartment: executor.department,
            executedByRole: executor.role,
            created_at: moment(String(item.created_at)).format("DD/MM/YYYY HH:mm:ss")
          }
        })
        this.modalTrackingOrderHostory.data.logTracking = logs
      } catch (error) {
        this.modalTrackingOrderHostory.data.logTracking = []
      } finally {
        this.modalTrackingOrderHostory.onLoadLogTrack = false
      }
		},
		async getNextApproval({ key } = {}) {
      this.modalTrackingOrderHostory.onLoadnextApprv = true
      try {
        const payload = {}
        if (key) payload.key = key

        const response = await api(this, transactionLogService.nextApproval(payload), false)
        this.modalTrackingOrderHostory.data.nextApprv = this.mapNextApproval(response.data)
      } catch (error) {
        this.modalTrackingOrderHostory.data.nextApprv = []
      } finally {
        this.modalTrackingOrderHostory.onLoadnextApprv = false
      }
		},
		// Gabungkan daftar user (name) dengan role dari receivers (to === 'role')
		mapNextApproval(data) {
			if (!data) return []
			const roles = (data.approval_criteria || [])
				.filter(r => r.to === 'role')
				.flatMap(r => r.values || [])
			const role = roles.join(', ')
			const users = data.users || []
			const hasil = users.map(u => ({ name: u.name, department: u.section_description || '-', role }))
			return hasil;
		},
		getResultIcon(result) {
			if (result === 'success') return { component: 'ni ni-check-bold', color: 'success', tooltip: 'Start' }
			if (result === 'approve') return { component: 'ni ni-check-bold', color: 'success', tooltip: 'Approved' }
			if (result === 'send_back') return { component: 'ni ni-bold-left', color: 'warning', tooltip: 'Sent Back' }
			if (result === 'reject') return { component: 'ni ni-fat-remove', color: 'danger', tooltip: 'Rejected' }
			return { component: 'ni ni-check-bold', color: 'secondary', tooltip: '' }
		},
		parseExecutedBy(raw) {
			if (!raw) return { name: '-', department: '', role: '' }
			try {
				let parsed = raw
				// Unwrap sampai mendapatkan object
				while (typeof parsed === 'string') {
					parsed = JSON.parse(parsed)
				}
				// Coba berbagai variasi key department (description dulu, baru fallback ke code)
				const department = parsed?.department_description
					|| parsed?.department_detail?.description
					|| parsed?.department_name
					|| parsed?.departement
					|| parsed?.department
					|| ''
				// Role bisa array (lebih dari satu) atau string
				const role = Array.isArray(parsed?.role)
					? parsed.role.filter(Boolean).join(', ')
					: (parsed?.role || '')
				return {
					name: parsed?.name || parsed?.username || '-',
					department,
					role
				}
			} catch (e) {
				return { name: '-', department: '', role: '' }
			}
		},
		distrupNav() {
      // Emit ke parent; fallback ke navPillDistrack bila parent menyediakannya
      this.$emit('close')
      if (typeof this.$parent?.navPillDistrack === 'function') {
        this.$parent.navPillDistrack()
      }
		}
	}
}
</script>

<style scoped>
.nav-pills .nav-link {
	color: #344767;
	background-color: #f6f9fc;
	border: 1px solid #e9ecef;
	font-weight: 600;
	transition: all 0.15s ease;
}

.nav-pills .nav-link:hover {
	background-color: #eef2ff;
}

.nav-pills .nav-link.active {
	color: #fff;
	background-color: #5e72e4;
	border-color: #5e72e4;
	box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
</style>
